// Sistema global para rastrear peticiones activas
class RequestTracker {
  constructor() {
    this.activeRequests = new Set();
    this.listeners = new Set();
  }

  // Agregar una petición activa
  addRequest(requestId) {
    this.activeRequests.add(requestId);
    this.notifyListeners();
  }

  // Remover una petición activa
  removeRequest(requestId) {
    this.activeRequests.delete(requestId);
    this.notifyListeners();
  }

  // Verificar si hay peticiones activas
  hasActiveRequests() {
    return this.activeRequests.size > 0;
  }

  // Obtener el número de peticiones activas
  getActiveCount() {
    return this.activeRequests.size;
  }

  // Suscribirse a cambios en el estado de peticiones
  subscribe(listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  // Notificar a todos los listeners
  notifyListeners() {
    this.listeners.forEach(listener => {
      listener(this.hasActiveRequests(), this.getActiveCount());
    });
  }

  // Limpiar todas las peticiones (útil para reset)
  clear() {
    this.activeRequests.clear();
    this.notifyListeners();
  }
}

// Instancia global
export const requestTracker = new RequestTracker();



